@import "src/style/lib";

.carousel {
  position: relative;

  &:hover .carousel-slide-button {
    opacity: 1;
  }

  > .carousel-container {
    overflow-y: hidden;
    overflow-x: scroll;
    scroll-snap-type: x mandatory;
    scrollbar-width: none;

    @include media-breakpoint-down("sm") {
      &:has(.cockpit-side_by_side) {
        height: auto;
        .carousel-slides {
          height: auto;
          .carousel-slide {
            height: auto;
          }
        }
      }
    }
  }

  > .carousel-container::-webkit-scrollbar {
    height: 0;
    width: 0;
  }

  > .carousel-container {
    > .carousel-slides {
      min-width: 100vw;
      min-width: 100cqw;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: flex-start;
      gap: 0;

      .carousel-slide {
        position: relative;
        display: flex;
        flex: 0 0 100vw;
        flex: 0 0 100cqw;
        scroll-snap-align: center;

        &::before {
          content: none;
        }

        &.cockpit-side_by_side .cockpit-side_by_side-row {
          width: 100%;
          .cockpit-side_by_side-image {
            @include media-breakpoint-down("sm") {
              flex: 0 0 40vh;
              border-radius: 1rem 1rem 0 0;
            }
          }
          .cockpit-side_by_side-content {
            @include media-breakpoint-down("sm") {
              font-size: 0.9em;
              flex: 0 1 100%;
              padding-top: 1.4rem;
              border-radius: 0 0 1rem 1rem;
            }
          }
        }
      }
      &.carousel-fixed-width-slides {
        min-width: fit-content;
        column-gap: 1.4rem;
        padding: 0 5rem;
        //Needed to show the padding on the last slide:
        &::after {
          content: "";
          padding-right: 0;
        }

        @include media-breakpoint-down("sm") {
          padding: 0 1rem;
          //Needed to show the padding on the last slide:
          &::after {
            content: "";
            padding-right: 1rem;
          }
        }

        .carousel-slide {
          flex: 0 0 28rem;

          &.herobox, &.image-box {
            margin: 1rem 0;
            border-radius: 1rem;
            box-shadow: 0.4rem 0.4rem 1rem rgba(0, 0, 0, 0.15);
            overflow: hidden;

            .herobox-content-wrapper {
              padding-top: 0;
              > .herobox-content {
                width: calc(100% - 4rem);
              }   
            }
          }

          &.cockpit-side_by_side .cockpit-side_by_side-row {
            flex-direction: column;
            gap: 0;
            border-radius: 1rem;
            box-shadow: 0.4rem 0.4rem 1rem rgba(0, 0, 0, 0.15);
            .cockpit-side_by_side-image {
              flex: 0 0 20rem;
              min-height: auto;
              border-radius: 1rem 1rem 0 0;
            }
            .cockpit-side_by_side-content {
              font-size: 0.9em;
              flex: 0 1 100%;
              padding: 1.4rem 2rem 4rem 2rem;
              border-radius: 0 0 1rem 1rem;
              background-color: #fff;
            }
          }
        }
      }
    }
  }

  &.carousel-navtype-tabs {
    > .carousel-container {
      > .carousel-slides {
        @include media-breakpoint-down("sm") {
          column-gap: 1rem;
          padding: 0 2rem;
          //Needed to show the padding on the last slide:
          &::after {
            content: "";
            padding-right: 1rem;
          }
          > .carousel-slide {
            scroll-snap-align: center;
            flex: 0 0 calc(100vw - 4rem);
          }
        }
      }
    }
    .next-slide-button {
      top: 23.1rem;
      bottom: auto;
    }
  }

  .carousel-thumbs {
    display: flex;
    flex-wrap: nowrap;
    gap: 0.5rem;
    margin-bottom: 2rem;
    justify-content: center;
    align-items: center;
    transform: translateY(-2rem);
    user-select: none;

    @media print {
      display: none;
    }

    .slide-thumb {
      container-type: inline-size;
      flex: 0 1 10rem;
      display: flex;
      justify-content: center;
      min-height: 7rem;
      margin: 0 -0.5px;
      position: relative;
      cursor: pointer;
      transition: transform 0.5s ease-in-out;

      &:not(.slide-thumb-placeholder) {
        animation: showCarouselThumb 1s ease-out;

        @keyframes showCarouselThumb {
          0% {
            transform: translateY(-0.5rem);
            opacity: 0;
          }
          100% {
            transform: translateY(0);
            opacity: 1;
          }
        }
      }

      .slide-thumb-bkg {
        filter: brightness(65%) grayscale(50%);
        transition: filter 0.5s ease-out;
        border-radius: 1rem;
        overflow: hidden;
        box-shadow: var(--heavy-box-shadow);

        &:after {
          content: "";
          position: absolute;
          inset: 0;
          box-shadow: var(--highlight-box-shadow);
          border-radius: 1rem;
          pointer-events: none;
        }
      }

      .slide-thumb-label {
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        font-weight: 600;
        position: absolute;
        inset: 0;
        height: 100%;
        width: 100%;
        padding: 0 1rem 1rem;
        text-align: center;
        font-size: 0.8rem;
        text-shadow: 0 0 5px rgba(0, 0, 0, 0.7);
        opacity: 1;
        transition: opacity 1s ease-out;
      }

      @container (max-width: 9rem) {
        & .slide-thumb-label {
          font-size: 0.7rem;
          font-weight: 400;
        }
      }

      @container (max-width: 6rem) {
        & .slide-thumb-label {
          display: none;
        }
      }

      .slide-thumb-arrow {
        position: absolute;
        bottom: 100%;
        width: 1.4rem;
        height: 0.7rem;
        opacity: 0;
        transform: scaleY(0);
        transition: opacity 0.25s ease-out, transform 0.25s ease-out;
        transform-origin: center bottom;
      }

      &.active {
        cursor: default;

        .slide-thumb-bkg {
          filter: none;
        }

        .slide-thumb-label {
          opacity: 0;
        }

        .slide-thumb-arrow {
          opacity: 1;
          transform: scaleY(1);
          transition: opacity 0.5s 0.25s ease-out,
            transform 0.25s 0.25s ease-out;
        }
      }

      &.slide-thumb-placeholder {
        background: #ffffff;

        > .slide-thumb-placeholder-bkg {
          position: absolute;
          inset: 0;
          animation: 1s infinite animLoadingPlaceholder;
          display: flex;
          justify-content: center;
          align-items: center;
          background: rgba(0, 0, 0, 0.15);
          color: #fff;
        }

        > .slide-thumb-placeholder-label {
          position: absolute;
          inset: 0;
          display: flex;
          justify-content: center;
          align-items: center;

          > div {
            animation: 1s infinite animLoadingPlaceholderText;
            background: rgba(255, 255, 255, 0.3);
            height: 1em;
            width: 5em;
          }
        }
      }
    }
  }

  .carousel-tabs {
    display: flex;
    justify-self: center;
    justify-content: center;
    width: 100%;
    padding: 0 0.5rem;
    .carousel-tabs-floating {
      position: sticky;
      z-index: 100;
      top: calc(var(--menu-height) + var(--padding-top) + 0.25rem);
      left: 0;
      background: var(--bjelin-light-glass-bg);
      backdrop-filter: var(--bjelin-glass-backdrop-filter);
      box-shadow: var(--highlight-box-shadow), var(--heavy-box-shadow);
      border-radius: 2rem;
    }
    @include media-breakpoint-down("md") {
      justify-content: flex-start;
      overflow-x: scroll;
      scroll-snap-type: x mandatory;
      scrollbar-width: none;
      &::-webkit-scrollbar {
        height: 0;
        width: 0;
      }
      .carousel-tabs-inner {
        .slide-tab {
          scroll-snap-align: center;
        }
      }
    }

    .carousel-tabs-inner {
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: center;
      width: fit-content;
      height: 4rem;
      user-select: none;

      @media print {
        display: none;
      }

      .slide-tab {
        height: 4rem;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;

        .slide-tab-label {
          color: #000;
          font-weight: 400;
          text-align: center;
          font-size: 1rem;
          text-transform: uppercase;
          white-space: nowrap;
          opacity: 0.4;
          transition: opacity 1s ease-out, border-bottom 0.25s ease-out;
          padding: 0.7rem 1rem;
          border-bottom: 3px solid transparent;
        }

        &.active {
          .slide-tab-label {
            opacity: 1;
            border-bottom: 3px solid $primary;
          }
        }

        &.slide-tab-placeholder {
          background: #ffffff;

          > .slide-tab-placeholder-label {
            > div {
              animation: 1s infinite animLoadingPlaceholderText;
              background: rgba(255, 255, 255, 0.3);
              height: 1em;
              width: 5em;
            }
          }
        }
      }
    }
  }

  .carousel-horizontal-markers {
    position: absolute;
    bottom: 1em;
    left: calc(50% - 10em);
    width: 20em;
    z-index: 100;
    display: flex;
    justify-content: center;
    animation: show-horizontal-markers 0.5s ease-out;

    @keyframes show-horizontal-markers {
      0% {
        transform: translateY(1rem);
        opacity: 0;
      }
      100% {
        transform: translateY(0);
        opacity: 1;
      }
    }
    > .markers-container {
      background: rgba(255, 255, 255, 0.8);
      border-radius: 1rem;
      box-shadow: var(--highlight-box-shadow), var(--heavy-box-shadow);
      height: 1.4rem;
      padding: 0 0.7rem;
      backdrop-filter: blur(5px);
      display: flex;
      justify-content: center;
      align-items: center;
      column-gap: 0.6rem;
    }

    .marker {
      cursor: pointer;
      margin: 0;
      width: 0.6rem;
      position: relative;
      height: 0.6rem;
      background: $bjelin-dark-grey;
      opacity: 0.3;
      border-radius: 0.3rem;
      transition: background 0.5s ease, transform 1s ease, opacity 0.75s ease,
        width 0.5s ease, border-radius 0.5s ease, margin 0.5s ease;
      /*box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);*/
      &.active {
        opacity: 1;
        background: $bjelin-dark-grey;
        box-shadow: var(--heavy-box-shadow);
        width: 1.2rem;
        border-radius: 0.6rem;
        transform: scale(1.2);
        & ~ .active {
          margin-left: -1em;
        }
      }
    }

    &.dots {
      bottom: -1rem;
      > .markers-container {
        padding: 0.8rem;
      }
    }

    &.bold-markers > .markers-container {
      background-color: rgb(57, 57, 57);
      border-radius: 1.2rem;
    }

    &.small-markers > .markers-container {
      column-gap: 0.3em;

      .marker {
        cursor: pointer;
        width: 0.4em;
        height: 0.4em;
        background: rgba(0, 0, 0, 0.7);
        border-radius: 0.2em;
        transition: width 0.5s ease;
        box-shadow: none;

        &.active {
          margin: 0;
          width: 1.2em;
          transform: none;
        }
      }
    }
  }
}

.product-carousel > .carousel > .carousel-container {
  .carousel-slides {
    column-gap: 1rem !important;
    height: 32.5rem;
    > .carousel-slide {
      flex: 0 0 20rem;
      display: flex;
      border-radius: 1rem;
      box-shadow: 0.4rem 0.4rem 1rem rgba(0, 0, 0, 0.15);
      margin-bottom: 1rem;
      background-color: #fff;
      > .product-preview {
        position: absolute;
        inset: 0;
        height: 31.5rem;
        > a {
          position: absolute;
          inset: 0;
          display: flex;
          flex-direction: column;
          gap: 0;

          .section1 {
            border-radius: 1rem 1rem 0 0;
            overflow: hidden;
          }
          .section2 {
            flex: 0 1 100%;
            background-color: #fff;
            padding: 1em;
          }
          .section3 {
            border-radius: 0 0 1rem 1rem;
            background-color: #fff;
            padding: 0 1em 1em 1em;
            > .specs {
              display: none;
            }
          }
        }
      }
    }
  }
}

.carousel.gallery-carousel {
  position: absolute;
  inset: 0;

  .carousel-container {
    height: 100%;
  }
  .carousel-slides {
    height: 100%;
  }
  .carousel-slide {
    height: 100%;
  }
}
